const CORRESPONDENCE_CONSTANTS = {
  CORRESPONDENCE: 'Correspondence',
  VIEW_CORRESPONDENCE: 'Correspondence/:correspondenceUid',
};
export default CORRESPONDENCE_CONSTANTS;
